import {
  DETAILS_LOAD,
  DETAILS_LOAD_SUCCESS,
  SET_DETAIL_SKIP,
  SET_DETAIL_SEASON
} from './actions';

const initialState = {
  contentDetails: null,
  moreDetails: null,
  detailSkip: null,
  seasonSelected: null
};

export function detailsReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case DETAILS_LOAD:
      return {
        ...state,
        contentDetails: null,
        moreDetails: null
      };

    case DETAILS_LOAD_SUCCESS:
      return {
        ...state,
        contentDetails: data,
        moreDetails: action.more
      };

    case SET_DETAIL_SKIP:
      return {
        ...state,
        detailSkip: data
      };

    case SET_DETAIL_SEASON:
      return {
        ...state,
        seasonSelected: data
      };

    default:
      return state;
  }
}
